import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import workflowsReducer from './data/reducer';
import workflowsSaga from './data/sagas';
import routes from './routes';
import workStepModalReducer from './workStepsModal/data/reducer';
import workStepModalSaga from './workStepsModal/data/sagas';
import workflowModalReducer from './workflowModal/data/reducer';
import workflowModalSaga from './workflowModal/data/sagas';

const reducer = combineReducers({
  workflowModal: workflowModalReducer,
  workflowsLists: workflowsReducer,
  workStepModal: workStepModalReducer,
});

const saga = function* () {
  yield all([workflowModalSaga(), workflowsSaga(), workStepModalSaga()]);
};

export { reducer, saga, routes };
